import { useState, useEffect } from 'react';
import PopupImage from '../../assests/images/event-horn-ok.png'
export default function EventPopup() {
  const [isOpen, setIsOpen] = useState(false);
  const [shouldShowEvent, setShouldShowEvent] = useState(false);

  useEffect(() => {
    // Check if current date is before December 1st, 2025
    const currentDate = new Date();
    const endDate = new Date('2025-12-01T00:00:00');
    
    if (currentDate < endDate) {
      setShouldShowEvent(true);
      
      // Show popup after 1.5 seconds
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  // Don't render anything if event period has passed
  if (!shouldShowEvent) {
    return null;
  }

  return (
    <>
      {/* Floating Event Button */}
      <button
        onClick={handleOpen}
        className="fixed bottom-6 left-6 z-50 bg-gradient-to-r from-amber-600 to-amber-700 text-white px-6 py-4 rounded-full shadow-2xl hover:shadow-amber-500/50 transition-all duration-300 hover:scale-105 cursor-pointer flex items-center gap-3 group animate-pulse-slow"
      >
        <div className="w-3 h-3 bg-green-400 rounded-full animate-ping absolute -top-1 -right-1"></div>
        <div className="w-3 h-3 bg-green-400 rounded-full absolute -top-1 -right-1"></div>
        <i className="ri-calendar-event-fill text-xl"></i>
        <span className="font-semibold text-sm whitespace-nowrap">
          We're at Delhi's Food Festival!
        </span>
        <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
      </button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 bg-black/60 z-[100] transition-opacity duration-300"
            onClick={handleClose}
          />
          
         {/* Popup */}
<div className="fixed inset-0 z-[101] flex items-center justify-center p-2 sm:p-4">
  <div className="bg-white rounded-2xl w-full max-w-xl overflow-auto max-h-[90vh] shadow-2xl transform transition-all duration-300 scale-100 animate-popup relative">

    {/* Close Button */}
    <button
      onClick={handleClose}
      className="absolute top-3 right-3 z-20 w-9 h-9 flex items-center justify-center bg-white/90 hover:bg-white rounded-full shadow-lg transition-all duration-200 hover:scale-110 cursor-pointer"
    >
      <i className="ri-close-line text-xl text-gray-700"></i>
    </button>

    {/* Event Image */}
    <div className="relative w-full h-[220px] sm:h-[280px] overflow-hidden flex items-center justify-center bg-white">
      <img
        src={PopupImage}
        alt="Delhi Event"
        className="w-full h-full object-contain"
      />
    </div>

    {/* Content */}
    <div className="p-4 sm:p-6 text-center">
      <div className="inline-block px-3 py-1 bg-amber-100 text-amber-800 rounded-full text-xs sm:text-sm font-semibold mb-3">
        Special Event
      </div>

      <h2 className="text-2xl sm:text-3xl font-bold text-amber-900 mb-2 leading-tight">
        We're at Delhi's Biggest
        <span className="block text-amber-600">Food Festival!</span>
      </h2>

      <p className="text-gray-600 text-sm sm:text-base mb-4 max-w-md mx-auto">
        Join us at Horn OK Please 15.0! Exclusive tastings, live brewing demos,
        and festival-only offers.
      </p>

      <div className="bg-amber-50 rounded-xl p-4 sm:p-5 mb-4">
        <p className="text-amber-900 text-lg sm:text-xl font-semibold mb-1">
          Come Visit Us!
        </p>
        <p className="text-gray-600 text-sm sm:text-base">
          We'd love to meet you and share our passion for coffee & matcha.
        </p>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-xs sm:text-sm text-gray-500 pt-3 border-t border-gray-200">
        <div className="flex items-center gap-2">
          <i className="ri-map-pin-line text-amber-600"></i>
          <span>Jawaharlal Nehru Stadium, New Delhi</span>
        </div>
        <div className="flex items-center gap-2">
          <i className="ri-calendar-event-line text-amber-600"></i>
          <span>29 – 30 Nov 2025</span>
        </div>
      </div>
    </div>
  </div>
</div>

        </>
      )}

      <style>{`
        @keyframes popup {
          0% {
            opacity: 0;
            transform: scale(0.9) translateY(20px);
          }
          100% {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }
        .animate-popup {
          animation: popup 0.3s ease-out;
        }
        @keyframes pulse-slow {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.02);
          }
        }
        .animate-pulse-slow {
          animation: pulse-slow 3s ease-in-out infinite;
        }
      `}</style>
    </>
  );
}